import { ArticlesSlider } from '@notino/react-styleguide';

export default ArticlesSlider;
